import React from 'react'
import { BaseFieldProps } from './index'
import Label from 'particles/Label'
import CommentContainer from 'components/Shared/Comment'
import IconButton from 'particles/Button/IconButton'

interface FieldTitleAndSubTitleProps extends BaseFieldProps {
    isReadOnly?: boolean
    onClose?: () => void
}
const FieldTitleAndSubTitle: React.FC<FieldTitleAndSubTitleProps> = ({
    title,
    subtitle,
    isRequired = false,
    onClose,
    isReadOnly = false,
    identifier,
}) => {
    return (
        <div style={{ display: 'flex' }}>
            <CommentContainer identifier={identifier}>
                <Label title={title ?? ''} subtext={subtitle} isRequired={isRequired} />
            </CommentContainer>
            {onClose && !isReadOnly && <IconButton icon="x" form="icon" size="xs" color="neutral" onClick={onClose} />}
        </div>
    )
}
export default FieldTitleAndSubTitle
